import { render } from "./EntryDetails.vue?vue&type=template&id=0819b747&scoped=true"
import script from "./EntryDetails.vue?vue&type=script&lang=ts"
export * from "./EntryDetails.vue?vue&type=script&lang=ts"

import "./EntryDetails.vue?vue&type=style&index=0&id=0819b747&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0819b747"

export default script